import { linkClickHandler } from '@/utils';
import React, { forwardRef } from 'react';

export interface ISunnyLinkProps
  extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  disabled?: boolean;
  noHistory?: boolean;
}

type THandleClick = ((e: MouseEvent | React.MouseEvent<Element, MouseEvent>) => void | Promise<void>) | undefined;

const SunnyLink: React.ForwardRefRenderFunction<HTMLAnchorElement, ISunnyLinkProps> = (
  { disabled, href, onClick, noHistory = false, ...props },
  ref,
) => {
  let handleClick: THandleClick = linkClickHandler(href, onClick, { noHistory });

  if (disabled) {
    handleClick = undefined;
  } else if (props.target === '_blank' || props.target === '_parent') {
    /* linkClickHander 가 preventDefault 를 포함하고 있어 새창으로 열고 싶을 땐 onClick 을 실행해야한다 */
    /* _parent는 KTX예매완료 페이지에서 iframe안에 있는 추천이 쓴다 */
    handleClick = onClick;
  }

  return <a ref={ref} href={disabled ? undefined : href} target={props.target} {...props} onClick={handleClick} />;
};

export default forwardRef<HTMLAnchorElement, ISunnyLinkProps>(SunnyLink);
